import { z } from 'zod'
import type { BaseSchema } from './base'
import { baseSchema } from './base'
import type { ButtonSchema } from './button'
import { buttonSchema } from './button'
import type { CardSchema } from './card'
import { cardSchema } from './card'
import type { DatePickerSchema } from './date-picker'
import { datePickerSchema } from './date-picker'
import type { DateRangeSchema } from './date-range'
import { dateRangeSchema } from './date-range'
import type { DescriptionsSchema } from './descriptions'
import { descriptionsSchema } from './descriptions'
import type { DivSchema } from './div'
import { divSchema } from './div'
import type { FlexSchema } from './flex'
import { flexSchema } from './flex'
import type { FormSchema } from './form'
import { formSchema } from './form'
import type { formItemSchema, FormItemSchema } from './form-item'
import { infiniteListSchema } from './infinite-list'
import type { InputNumberSchema } from './input-number'
import { inputNumberSchema } from './input-number'
import type { InputTextSchema } from './input-text'
import { inputTextSchema } from './input-text'
import type { LinkSchema } from './link'
import { linkSchema } from './link'
import type { QueryListSchema } from './query-list'
import { queryListSchema } from './query-list'
import type { SelectSchema } from './select'
import { selectSchema } from './select'
import type { ServiceSchema } from './service'
import { serviceSchema } from './service'
import type { SpanSchema } from './span'
import { spanSchema } from './span'
import type { TableSchema } from './table'
import { tableSchema } from './table'
import type { ViewportSchema } from './viewport'
import { viewportSchema } from './viewport'

export const schemaUnion = z.union([
  buttonSchema,
  cardSchema,
  datePickerSchema,
  dateRangeSchema,
  flexSchema,
  formSchema,
  infiniteListSchema,
  inputNumberSchema,
  inputTextSchema,
  linkSchema,
  queryListSchema,
  selectSchema,
  serviceSchema,
  spanSchema,
  tableSchema,
  viewportSchema,
  descriptionsSchema,
])

export type SchemaUnion = z.infer<typeof schemaUnion>

export type SchemaType = z.infer<typeof schemaUnion>['type']

export {
  baseSchema,
  buttonSchema,
  cardSchema,
  datePickerSchema,
  dateRangeSchema,
  descriptionsSchema,
  divSchema,
  flexSchema,
  formItemSchema,
  formSchema,
  infiniteListSchema,
  inputNumberSchema,
  inputTextSchema,
  linkSchema,
  queryListSchema,
  selectSchema,
  serviceSchema,
  spanSchema,
  tableSchema,
  viewportSchema,
}

export type {
  BaseSchema,
  ButtonSchema,
  CardSchema,
  DatePickerSchema,
  DateRangeSchema,
  DescriptionsSchema,
  DivSchema,
  FlexSchema,
  FormItemSchema,
  FormSchema,
  InputNumberSchema,
  InputTextSchema,
  LinkSchema,
  QueryListSchema,
  SelectSchema,
  ServiceSchema,
  SpanSchema,
  TableSchema,
  ViewportSchema,
}
